import React from 'react';
import { MapPinIcon, MailIcon, PhoneIcon, FacebookIcon, InstagramIcon, MapIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0d1d2e] text-cream pt-20 pb-10 border-t-8 border-orange" data-id="element-52">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-53">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16" data-id="element-54">
          {/* Brand Column */}
          <div className="space-y-6" data-id="element-55">
            <div className="bg-tan inline-block p-3 rounded-sm shadow-lg" data-id="element-56">
              <img src="https://cdn.magicpatterns.com/uploads/6yupxKuByE6KFzX9hkPWGk/State_48_HVAC_Logo.png" alt="State 48 Logo" className="h-28 w-auto" data-id="element-57" />
            </div>
            <p className="text-blue-200 font-body max-w-xs" data-id="element-58">
              Providing honest, reliable heating and cooling services to Arizona
              families. Built on hard work and integrity.
            </p>
            <div className="flex space-x-3" data-id="element-59">
              <a href="https://www.facebook.com/State48HC" target="_blank" rel="noopener noreferrer" className="bg-navy p-2 rounded-full hover:bg-orange transition-colors border border-navy-700" aria-label="Facebook" data-id="element-60">
                <FacebookIcon className="h-5 w-5" data-id="element-61" />
              </a>
              <a href="https://www.instagram.com/state48hc" target="_blank" rel="noopener noreferrer" className="bg-navy p-2 rounded-full hover:bg-orange transition-colors border border-navy-700" aria-label="Instagram" data-id="element-62">
                <InstagramIcon className="h-5 w-5" data-id="element-63" />
              </a>
              <a href="https://maps.app.goo.gl/Wnu9TfwoN4Ms3Ueu9" target="_blank" rel="noopener noreferrer" className="bg-navy p-2 rounded-full hover:bg-orange transition-colors border border-navy-700" aria-label="Google Maps" data-id="element-64">
                <MapIcon className="h-5 w-5" data-id="element-65" />
              </a>
            </div>
          </div>

          {/* Contact Column */}
          <div data-id="element-66">
            <h3 className="text-2xl text-orange mb-6 font-sub uppercase tracking-wide" data-id="element-67">
              Contact Us
            </h3>
            <ul className="space-y-4 font-body text-blue-100" data-id="element-68">
              <li className="flex items-start gap-3" data-id="element-69">
                <PhoneIcon className="h-5 w-5 text-orange mt-1 flex-shrink-0" data-id="element-70" />
                <div data-id="element-71">
                  <span className="block text-sm text-blue-300 uppercase" data-id="element-72">
                    Phone
                  </span>
                  <a href="tel:6025842141" className="text-xl text-white hover:text-orange transition-colors" data-id="element-73">
                    602-584-2141
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-74">
                <MailIcon className="h-5 w-5 text-orange mt-1 flex-shrink-0" data-id="element-75" />
                <div data-id="element-76">
                  <span className="block text-sm text-blue-300 uppercase" data-id="element-77">
                    Email
                  </span>
                  <a href="mailto:info@state48hc.com" className="hover:text-orange transition-colors" data-id="element-78">
                    info@state48hc.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-79">
                <MapPinIcon className="h-5 w-5 text-orange mt-1 flex-shrink-0" data-id="element-80" />
                <div data-id="element-81">
                  <span className="block text-sm text-blue-300 uppercase" data-id="element-82">
                    Address
                  </span>
                  <a href="https://maps.app.goo.gl/Wnu9TfwoN4Ms3Ueu9" target="_blank" rel="noopener noreferrer" className="hover:text-orange transition-colors" data-id="element-83">
                    8722 N 83rd Dr
                    <br data-id="element-84" />
                    Peoria, AZ 85345
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-85">
                <MapPinIcon className="h-5 w-5 text-orange mt-1 flex-shrink-0 opacity-0" data-id="element-86" />
                <div data-id="element-87">
                  <span className="block text-sm text-blue-300 uppercase" data-id="element-88">
                    Service Area
                  </span>
                  <span data-id="element-89">
                    Phoenix, Scottsdale, Mesa, Gilbert,
                    <br data-id="element-90" />
                    Chandler & surrounding areas
                  </span>
                </div>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div data-id="element-91">
            <h3 className="text-2xl text-orange mb-6 font-sub uppercase tracking-wide" data-id="element-92">
              Quick Links
            </h3>
            <ul className="space-y-2 font-sub text-lg uppercase tracking-wide" data-id="element-93">
              <li data-id="element-94">
                <a href="#" className="text-blue-100 hover:text-orange transition-colors" data-id="element-95">
                  Home
                </a>
              </li>
              <li data-id="element-96">
                <a href="#services" className="text-blue-100 hover:text-orange transition-colors" data-id="element-97">
                  Services
                </a>
              </li>
              <li data-id="element-98">
                <a href="#story" className="text-blue-100 hover:text-orange transition-colors" data-id="element-99">
                  Our Story
                </a>
              </li>
              <li data-id="element-100">
                <a href="#reviews" className="text-blue-100 hover:text-orange transition-colors" data-id="element-101">
                  Reviews
                </a>
              </li>
              <li data-id="element-102">
                <a href="#" className="text-blue-100 hover:text-orange transition-colors" data-id="element-103">
                  Financing
                </a>
              </li>
              <li data-id="element-104">
                <a href="#" className="text-blue-100 hover:text-orange transition-colors" data-id="element-105">
                  Careers
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-blue-300 text-sm font-body" data-id="element-106">
          <p data-id="element-107">
            &copy; {new Date().getFullYear()} State 48 Home Comfort. All rights
            reserved. ROC #333333
          </p>
        </div>
      </div>
    </footer>;
}